export const ROUTES_APLICATION = {

  add: 'adicionar',
  detail: 'detalhes',
  home: 'home',
  notAllowed: 'nao-permitido',

  ambienteMonitoramento: {
    path: 'https://teleaula-dev.startbio.com.br/',
    environment: 'ambiente'
  },

  audit: {
    path: 'auditoria',

    userAudit: 'auditoria-de-usuarios',
    dataAudit: 'auditoria-de-dados'
  },
  exams: {
    path: 'exams',

    availability: 'disponiblidade-marcacao-exame',
    block: 'bloqueio-marcacao-exame',
    calendario: 'calendario',
    report: 'relatorio',
    schedulingExams: 'marcacao-de-exames',
    local: 'local',
    photoBiometrics: 'agendamento-foto-biometria',
    bloqueiofotobiometria: 'bloqueio-foto-biometria',
    bioexame: 'bioexame',
    localfotobiometria: 'local-fotobiometria',
    disponibilidadefotobiometria: 'disponibilidade-fotobiometria',
  },

  financial: {
    path: 'financeiro',

    accountPayment: 'meio-de-pagamento',
    bankAccount: 'conta-corrente',
    blockCfc: 'bloqueio-cfc',
    budgetForecast: 'previsao-orcamentaria',
    cashFlow: 'fluxocaixa',
    contracts: 'contratos',
    financialGroup: 'grupo-financeiro',
    membershipFee: 'membership-fee',
    paymentMode: 'forma-pagamento',
    people: 'pessoa',
    release: 'lancamento',
    releaseGroup: 'grupo-de-lancamento',
    releaseTypes: 'tipos-lancamento',
    accountDre: 'contas-dre',
    releaseTypesGroup: 'grupo-tipo-lancamento',
    relatorioPrevisaoOrcamentaria: 'relatorio-previsao-orcamentaria',
    resultCenter: 'centro-de-resultado',
    bank: 'bancos',
    shoppingCart: 'carrinho-de-compras',
    transparencyPortal: 'portal-transparencia',
  },

  management: {
    path: 'gestao',
    civilStatus: 'estado-civil',
    commissioning: 'comissionamento',
    corporateStructure: 'socios',
    document: 'documento',
    documentTemplate: 'template-documento',
    employeeContractTypeModule: 'tipos-contrato-de-trabalho',
    enrollmentCredit: 'creditos-matricula',
    holiday: 'feriado',
    membershipFee: 'membership-fee',
    notification: 'notification',
    products: 'produtos',
    role: 'perfil',
    transparencyPortal: 'portal-transparencia',
    typeCredit: 'tipo-de-credito',
    workingHoursEmployeeRoutingModule: 'horas-de-trabalho',
  },

  notifications: {
    path: 'notificacao'
  },

  practical_course: {
    path: 'curso-pratico',
    practical: 'pratico',
    timeMap: 'mapa-de-horas',
    vehicleAvailability: 'disponibilidade-de-veiculo',
    vehicleAvailabilityBlock: 'bloqueio-de-disponibilidade'
  },

  register: {
    path: 'cadastro',
    laudo: 'laudo',
    candidate: 'candidato',
    cfc: 'cfc',
    ciretrans: 'ciretrans',
    course: 'curso',
    enrollment: 'matricula',
    enrollmentData: 'dados-do-candidato',
    group: 'grupos',
    instructor: 'instrutor',
    user: 'usuarios',
    vehicle: 'veiculo',
    region: 'regiao',
    policeStation: 'delegacia',
  },

  theoretical_course: {
    path: 'curso-teorico',

    addCandidateToClass: 'adicionar-candidato-a-aula',
    grid: 'grade',
    manageSchedule: 'gerenciar-agendamento',
    serviceGrid: 'grade-de-servicos',
    theory: 'teorico',
  },

  user_settings: {
    path: 'configuracoes-de-usuarios',
    changePassord: 'alterar-senha',
    personalData: 'meus-dados',
    permissions: 'permissoes-de-usuario'
  },

  virtual: {
    path: 'https://portalba.renova.app.br/',
    environment: 'ambiente',
  },

  log: {
    path: 'log',
    scheduling: 'agendamento',
    cfc: 'cfc',
    instructor: 'instrutor',
    registration: 'matricula',
    candidateScheduling: 'agendamento-candidato',
    grid: 'grade'
  },

  reports: {
    path: 'relatorios',
    financialStatement: 'extrato-financeiro',
    financialConsolidated: 'consolidado-financeiro',
    financialDRE: 'relatorio-dre',
    financialCashFlow: 'relatorio-fluxo-de-caixa',
    financialDashboard: 'painel-financeiro',
  },
};
